<template>
  <v-toolbar
    class="#505050--text"
    :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
    :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-bottom: none; background-color: white'
                    : 'border: none; background-color: white'
                "
  >
    <v-text-field
      v-model="rSearch"
      append-icon="mdi-magnify"
      :label="$t('dataGridSearchLabel')"
      single-line
      hide-details
    ></v-text-field>
  </v-toolbar>
</template>

<script>
export default {
  name: "data-table-search-toolbar",
  props: {
    search: {
      type: String,
      required: true
    }
  },
  computed: {
    rSearch: {
      get: function() {
        return this.search;
      },
      set: function(newValue) {
        this.$emit("update:search", newValue);
      }
    }
  }
};
</script>

<style scoped>
</style>